<template>
  <div class="socials-header mr-2">
    {{ $t('Соцсети и мессенджеры') }}
  </div>

  <div class="tabs-wrap mr-2">
    <v-tabs color="#363636" bg-color="#F0F1F5" hide-slider v-model="tab">
      <v-tab value="one">{{ $t('Ссылки') }}</v-tab>
      <v-tab value="two">{{ $t('Вид') }}</v-tab>
    </v-tabs>
  </div>

  <div class="tabs-content">
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="one" class="tab-item" eager>
        <v-sheet>
              <draggable
                  v-model="form.links"
                  :force-fallback="true"
                  ghost-class="ghost"
                  chosen-class="chosen"
                  class="draggable"
                  handle=".handle"
                  :move="checkMove"
                  item-key="orderIndex">
                <transition-group type="transition">
                  <div v-for="(item, index) in form.links" :key="item.orderIndex" class="pr-2">
                    <div class="item">
                      <div class="icon-placeholder">
                        <img v-if="item.type" :src="`/socials/default/${socialIcon.detectSocialIcon(item.link)}`" :alt="item.type">
                      </div>
                      <v-text-field
                          variant="outlined"
                          :placeholder="$t('Введите ссылку')"
                          density="compact"
                          rounded="lg"
                          bg-color="#fff"
                          v-model="item.link"
                          class="name-field"
                          :class="{'pr-22px': (index >= 1 && index == form?.links.length - 1 && form?.links[1]?.link.length > 0)}"
                          clearable
                          validate-on="lazy"
                          :rules="linkRules"
                          :hide-details="!hasLinkError(item.link)"
                          @update:model-value="handleInput(index)"
                      >
                        <template v-slot:clear>
                          <v-hover>
                            <template v-slot:default="{ props }">
                              <v-icon :icon="ClearIcon" v-bind="props" @click="removeLink(index)"/>
                            </template>
                          </v-hover>
                        </template>
                      </v-text-field>
                      <div class="drag" :class="{'handle': index != form?.links.length -1}" v-if="form?.links[1]?.link.length > 0 && form?.links?.length > 1 && item?.link.length > 1">
                        <DragElement size="16" color="#8D959D"/>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
          <div class="mr-2">
            <v-btn variant="flat" color="primary" @click="save" :disabled="!hasChanges() || hasAnyError" rounded="lg" class="w-100 save-btn">
              {{$t('Сохранить')}}
            </v-btn>
          </div>

        </v-sheet>
      </v-tabs-window-item>

      <v-tabs-window-item value="two" class="tab-item" eager>
        <v-sheet>
          <div class="" v-if="tapStore.currentTapLang?.socials">
            <v-radio-group v-model="form.type" class="social-icons" hide-details>
              <v-radio class="radio-icons" value="default-bg" color="primary" :false-icon="OffIcon" :true-icon="OnIcon">
                <template v-slot:label>
                  <div class="icons-wrap">
                    <div class="icon-bg">
                      <img src="/socials/default/instagram.svg" alt="">
                    </div>
                    <div class="icon-bg">
                      <img src="/socials/default/whatsapp.svg" alt="">
                    </div>
                    <div class="icon-bg">
                      <img src="/socials/default/youtube.svg" alt="">
                    </div>
                    <div class="icon-bg">
                      <img src="/socials/default/behance.svg" alt="">
                    </div>
                  </div>
                </template>
              </v-radio>
              <v-radio class="radio-icons" value="default" color="primary" :false-icon="OffIcon" :true-icon="OnIcon">
                <template v-slot:label>
                  <div class="icons-wrap">
                    <div class="icon-no-bg">
                      <img src="/socials/default/instagram.svg" alt="">
                    </div>
                    <div class="icon-no-bg">
                      <img src="/socials/default/whatsapp.svg" alt="">
                    </div>
                    <div class="icon-no-bg">
                      <img src="/socials/default/youtube.svg" alt="">
                    </div>
                    <div class="icon-no-bg">
                      <img src="/socials/default/behance.svg" alt="">
                    </div>
                  </div>
                </template>
              </v-radio>
              <v-radio class="radio-icons" value="big" color="primary" :false-icon="OffIcon" :true-icon="OnIcon">
                <template v-slot:label>
                  <div class="icons-wrap">
                    <img src="/socials/default/instagram.svg" alt="" height="40">
                    <img src="/socials/default/whatsapp.svg" alt="" height="40">
                    <img src="/socials/default/youtube.svg" alt="" height="40">
                    <img src="/socials/default/behance.svg" alt="" height="40">
                  </div>
                </template>
              </v-radio>
              <v-radio class="radio-icons" value="black" color="primary" :false-icon="OffIcon" :true-icon="OnIcon">
                <template v-slot:label>
                  <div class="icons-wrap">
                    <img src="/socials/black/instagram.svg" alt="" height="40">
                    <img src="/socials/black/whatsapp.svg" alt="" height="40">
                    <img src="/socials/black/youtube.svg" alt="" height="40">
                    <img src="/socials/black/behance.svg" alt="" height="40">
                  </div>
                </template>
              </v-radio>
              <v-radio class="radio-icons" value="white" color="primary" :false-icon="OffIcon" :true-icon="OnIcon">
                <template v-slot:label>
                  <div class="icons-wrap">
                    {{$t('Белые иконки')}}
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </div>
          <div class="mr-2">
            <v-btn variant="flat" color="primary" @click="save" :disabled="!hasChanges()" rounded="lg" class="w-100 save-btn">
              {{$t('Сохранить')}}
            </v-btn>
          </div>
        </v-sheet>
      </v-tabs-window-item>
    </v-tabs-window>
  </div>
</template>

<script setup lang="ts">
import {ref, onMounted, nextTick, computed} from 'vue'
import {VueDraggableNext as draggable} from 'vue-draggable-next'
import OnIcon from '~/assets/icons/radio/on.vue'
import OffIcon from '~/assets/icons/radio/off.vue'
import {useTapStore} from "@/stores/tapStore.js";
import {useDialogStore} from "@/stores/dialogStore";
import { useChangeTracker } from "@/composables/useChangeTracker"
import { cloneDeep } from "lodash-es"
import {useI18n} from "vue-i18n";
import ClearIcon from "~/assets/icons/clear.vue";
import DragElement from "@/components/DragElement.vue";
import {useSocialIcon} from "~/composables/useSocialIcon";

const tapStore = useTapStore();
const dialogStore = useDialogStore()

const { t } = useI18n()
const socialIcon = useSocialIcon()


const form = ref({
  links: [{ orderIndex: 0, link: '', type: '' }],
  type: 'default',
})

function hasLinkError(value: string) {
  const hide = !value || (value.trim().length >= 3 && value.includes('.'))
  return !hide
}

const hasAnyError = computed(() =>
    form.value.links.some(item => hasLinkError(item.link))
)

let nextId = 1

const linkRules = [
  v => (!!v && v.trim().length >= 3) || t('Минимум {length} символа', { length: 3 }),
  v => (!!v && v.includes('.'))      || t('Ссылка должна содержать точку'),
]

const handleInput = async (index: number) => {
  const links = form.value.links
  const currentItem = links[index]
  const trimmedValue = currentItem?.link?.trim() ?? ''
  currentItem.type = socialIcon.detectSocialIcon(trimmedValue)

  if (index === links.length - 1 && trimmedValue) {
    await addEmptyLink()
    updateHeight()
    return
  }

  if (trimmedValue === '') {

    const nonEmptyItems = links.filter(item => item.link?.trim())

    links.length = 0
    links.push(...nonEmptyItems)

    links.push(currentItem)

    await addEmptyLink()

    updateHeight()
    return
  }

  let needUpdate = false
  while (links.length >= 3) {
    const last = links[links.length - 1]?.link?.trim()
    const prev = links[links.length - 2]?.link?.trim()

    if (!last && !prev) {
      links.pop()
      needUpdate = true
    } else {
      break
    }
  }

  if (needUpdate) {
    await nextTick()
    updateHeight()
  } else {
    updateHeight()
  }
}

const checkMove = (evt: any) => {
  const list = form.value.links;
  const lastIndex = list.length - 1;

  const draggedIndex = evt.draggedContext.index;
  const targetIndex = evt.relatedContext.index;
  const willInsertAfter = evt.willInsertAfter ?? false;

  if (draggedIndex === lastIndex) {
    return false;
  }

  if (willInsertAfter && targetIndex === lastIndex) {
    return false;
  }

  return true;
};

const addEmptyLink = async () => {
  const activeTab = document.querySelector('.tab-item.v-window-item--active') as HTMLElement
  if (!activeTab) return

  form.value.links.push({
    orderIndex: nextId++,
    link: '',
    type: ''
  })

  await nextTick()
  updateHeight()
  await nextTick()

  activeTab.scrollTop = activeTab.scrollHeight
}

const save = async () => {
  const dataForSave = form.value.links.filter(item => {
    const show = item.link && item.link.trim().length > 0;
    if(show && !/^https?:\/\//i.test(item.link)) {
      item.link = 'https://' + item.link
    }
    return show
  })

  tapStore.setTapSocials(dataForSave, form.value.type)
  setOriginal(form)
  dialogStore.close()
  tapStore.currentTapLang.infoChanged = true
}

const removeLink = (index) => {
  if (form?.value.links.length > 1) {
    form?.value.links.splice(index, 1)
  }
  updateHeight()
}

const tab = ref<string>('one')
const maxHeight = ref<number>(0)

const updateHeight = () => {
  const items = document.querySelectorAll('.tab-item') as NodeListOf<HTMLElement>
  if (items.length === 0) {
    maxHeight.value = 0
    return
  }

  const topPadding = 20 + 13 + 8 + 24 + 30 + 16 + 36 + 24
  const availableHeight = window.innerHeight - topPadding

  const activeItem = document.querySelector('.tab-item.v-window-item--active') as HTMLElement
  if (!activeItem) return

  requestAnimationFrame(() => {
    activeItem.style.height = 'auto'
    activeItem.style.overflowY = 'visible'

    const naturalHeight = activeItem.scrollHeight

    let finalHeight = naturalHeight
    let needScroll = false

    if (naturalHeight > availableHeight) {
      finalHeight = availableHeight
      needScroll = true
    }

    items.forEach((el) => {
      el.style.height = finalHeight + 'px'
      el.style.overflowY = needScroll && el.classList.contains('v-window-item--active') ? 'auto' : 'hidden'
    })

    maxHeight.value = finalHeight
  })
}

const { hasChanges, setOriginal } = useChangeTracker(form)

onMounted(() => {
  if (tapStore.currentTapLang?.socials) {
    form.value = cloneDeep({
      links: tapStore.currentTapLang.socials,
      type: tapStore.currentTapLang.socialView
    })

    const maxId = form.value.links.reduce((m, l) => Math.max(m, l.orderIndex), 0)
    nextId = maxId + 1

    form.value.links.push({
      orderIndex: nextId++,
      link: '',
      type: ''
    })
  }

  setOriginal(form)
  dialogStore.setCheckChanges(hasChanges)
  updateHeight()
})


</script>

<style scoped lang="sass">
.tab-item
  min-height: 300px
.draggable
  display: flex
  flex-direction: column
  gap: 16px
.delete-link
  position: absolute
  right: 34px
  top: 8px
.chosen
  opacity: 1 !important
  &:last-child
    margin-bottom: 0

.ghost
  opacity: 0 !important
.social-icons
  padding: 0 8px
  .icons-wrap
    display: flex
    gap: 12px
    .icon-bg,
    .icon-no-bg
      width: 40px
      height: 40px
      display: grid
      place-items: center
      img
        width: 24px
        height: 24px
    .icon-bg
      background: #F6F7F8
      border-radius: 12px

.socials-header
  font-size: 20px
  font-weight: 600
  text-align: center
  margin-bottom: 16px
.links-wrap
  gap: 16px
  width: 100%
  flex-direction: column
.tabs-wrap
  margin-bottom: 24px
.drag
  display: flex
  align-items: center
  height: 40px
  cursor: all-scroll
.save-btn
  margin-top: 16px
.icon-placeholder
  width: 40px
  height: 40px
  background: #F6F7F8
  border-radius: 12px
  display: grid
  place-items: center
  img
    width: 24px
    height: 24px

.tabs-content
  overflow: auto
  position: relative
  transition: height 0.25s ease

.item
  display: flex
  width: 100%
  gap: 6px
  position: relative


</style>
